import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faClipboardList, faTools, faUserCog, faUsers, faListAlt, faTruck, faListOl, faBook, faNewspaper, faCalendar, faPhone, faTablet, faImages, faSync, faBookOpen } from '@fortawesome/free-solid-svg-icons'
import { useAuth, useLanguage } from '../../context'
import { useNavigate } from 'react-router-dom'
import { logsDatabase } from '../../indexedDB'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'inline-block',
        textAlign: 'center',
        padding: 10,
        width: '25%',
        // minWidth: 280,
        backgroundColor: 'transparent'
    },
    icon: {
        padding: 20,
        width: '100%'
    },
    button: {
        minWidth: '100%'
    },
    buttonSelection: {
        backgroundColor: '#F9F9F9',
        color: '#505050',
        width: '100%',
        // minWidth: 285,
        height: '100%',
        minHeight: 300,
        borderRadius: 20,
        fontFamily: 'Arial, Helvetica, sans-serif',
        textTransform: 'none',
        margin: 10
    },
    iconButton: {
        color: '#BE2E26'
    }
}))

const CardButton = ({ variant, disableButton, sx }) => {
    const { dictionary } = useLanguage()
    const navigate = useNavigate()

    const handleTypeIcon = () => {
        switch (variant) {
        case 'inspection':
            return (<FontAwesomeIcon icon={faSearch} size='4x' className={'iconButton'}/>)
        case 'assignment':
            return (<FontAwesomeIcon icon={faListAlt} size='4x' className={'iconButton'}/>)
        case 'machines':
            return (<FontAwesomeIcon icon={faTruck} size='4x' className={'iconButton'}/>)
        case 'maintenance':
            return (<FontAwesomeIcon icon={faTools} size='4x' className={'iconButton'}/>)
        case 'reports':
            return (<FontAwesomeIcon icon={faClipboardList} size='4x' className={'iconButton'}/>)
        case 'administration':
            return (<FontAwesomeIcon icon={faUserCog} size='4x' className={'iconButton'}/>)
        case 'users':
            return (<FontAwesomeIcon icon={faUsers} size='4x' className={'iconButton'}/>)
        case 'roles':
            return (<FontAwesomeIcon icon={faListOl} size='4x' className={'iconButton'}/>)
        case 'patterns':
            return (<FontAwesomeIcon icon={faBook} size='4x' className={'iconButton'}/>)
        case 'news':
            return (<FontAwesomeIcon icon={faNewspaper} size='4x' className={'iconButton'}/>)
        case 'calendar':
            return (<FontAwesomeIcon icon={faCalendar} size='4x' className={'iconButton'}/>)
        case 'machinesAdmin':
            return (<FontAwesomeIcon icon={faTruck} size='4x' className={'iconButton'}/>)
        case 'dispositivos':
            return (<FontAwesomeIcon icon={faTablet} size='4x' className={'iconButton'}/>)
        case 'gallery':
            return (<FontAwesomeIcon icon={faImages} size='4x' className={'iconButton'}/>)
        case 'admin-crons-sync':
            return (<FontAwesomeIcon icon={faSync} size='4x' className={'iconButton'}/>)
        case 'admin-manuals':
            return (<FontAwesomeIcon icon={faBookOpen} size='4x' className={'iconButton'}/>)
        }
    }
    const handleTypeText = () => {
        switch (variant) {
        case 'inspection':
            return dictionary?.welcome?.inspectionButton || 'Inspección'
        case 'assignment':
            return dictionary?.welcome?.assignmentButton || 'Asignaciones'
        case 'machines':
            return dictionary?.welcome?.machinesButton || 'Máquinas'
        case 'maintenance':
            return dictionary?.welcome?.maintenanceButton || 'Mantenimiento'
        case 'reports':
            return dictionary?.welcome?.reportsButton || 'Reportes'
        case 'administration':
            return dictionary?.welcome?.administrationButton || 'Administración'
        case 'users':
            return dictionary?.admin?.adminUsersButton || 'Usuarios'
        case 'roles':
            return dictionary?.roles?.rolesUsersButton || 'Roles'
        case 'patterns':
            return dictionary?.patterns?.patternsButton || 'Pautas'
        case 'news':
            return dictionary?.news?.newsButton || 'Novedades'
        case 'calendar':
            return dictionary?.calendar?.calendarButton || 'Calendario'
        case 'machinesAdmin':
            return dictionary?.admin?.machinesAdmin || 'Máquinas Admin'
        case 'dispositivos':
            return dictionary?.admin?.dispositivos || 'Dispositivos'
        case 'gallery':
            return dictionary?.admin?.gallery || 'Galería'
        case 'admin-crons-sync':
            return 'Crons & Sincronización'
        case 'admin-manuals':
            return 'Gestión de Manuales'
        }
    }

    return (
        <Button onClick={() => { navigate(`/${variant}`) }} variant="contained" className={'buttonSelection'} disabled={disableButton} sx={sx}>
            <div className={'icon'}>
                {handleTypeIcon()}
                <br />
                <p className='button-font-size'>{handleTypeText()}</p>
            </div>
        </Button>
    )
}

CardButton.propTypes = {
    variant: PropTypes.oneOf(['inspection', 'assignment', 'machines', 'maintenance', 'reports', 'configuration', 'administration', 'users', 'roles', 'patterns', 'news', 'calendar', 'machinesAdmin', 'dispositivos', 'gallery', 'admin-crons-sync', 'admin-manuals']),
    disableButton: PropTypes.bool,
    sx: PropTypes.object
}

export default CardButton
